import React from "react";
import InputMask from "react-input-mask";
import constants from "../../../common/constants";
import "./MaskedInput.css";
import { memo } from "react";

function MaskedInput(props) {
  return (
    <>
      <InputMask
        type={props.type !== undefined ? props.type : "text"}
        disabled={props.disabled}
        mask={props.mask}
        data-cy={props.datacy}
        {...props.register(props.name)}
        onChange={props.handleChange}
        ref={props.inputRef}
        value={props.value}
        formatChars={props.formatChars}
        onKeyDown={(e) => {
          if (e.keyCode === 32) {
            e.preventDefault();
          }
        }}
        onClick={props.handleClick}
        onMouseEnter={props.handleHover}
        className={
          "border text-gray-900 text-base rounded-[2px] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-900 dark:placeholder-gray-800 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 mb-2 phoneInput" +
          props.className
        }
        placeholder={
          props.errors ? props.t("RequiredFieldErrMsg") : props.placeholder
        }
        style={{
          "--placeholder-color": props.errors
            ? constants.TextBoxErrorMsgCss.placeholderColor
            : "",
          "--placeholder-fontweight": props.errors
            ? constants.TextBoxErrorMsgCss.placeHolderFontWeight
            : "",
          "--placeholder-fontsize": props.errors
            ? constants.TextBoxErrorMsgCss.placeHolderFontSize
            : "",
          border: props.errors ? constants.TextBoxErrorMsgCss.borderCss : "",
          "--placeholder-opacity": props.errors
            ? constants.TextBoxErrorMsgCss.placeHolderFontOpacity
            : "0.5",
        }}
        maskChar={""}
        onBlur={props?.handleBlur}
      />
      {/* <span className="font-semibold text-secondary-red">
        {props.errors && props.t("RequiredFieldErrMsg")}
      </span> */}
    </>
  );
}

export default memo(MaskedInput);
